// the sidecar's snapshot, fetched from api/snapshot (the Pages Function in production, serve.mjs locally)
// every two minutes. Screens read it when they draw, so a newer snapshot shows up on the next pass of the loop.

const URL_PATH = 'api/snapshot';
const REFRESH_MS = 2 * 60 * 1000;

let snapshot = null;
const listeners = new Set();

const load = async () => {
	try {
		const response = await fetch(URL_PATH, { cache: 'no-store' });
		if (!response.ok) throw new Error(`${URL_PATH} ${response.status}`);
		snapshot = await response.json();
		listeners.forEach((fn) => fn(snapshot));
	} catch (error) {
		// keep the last one; each screen decides whether what it has is too old to show
		console.warn('Russian Hill Local snapshot:', error.message);
	}
};

const first = load();
setInterval(load, REFRESH_MS);

// resolves once the first fetch has finished, with or without a snapshot
const ready = () => first.then(() => snapshot);
const data = (name) => snapshot?.data?.[name] ?? null;
const fetchedAt = (name) => snapshot?.sources?.[name]?.fetchedAt ?? null;
const onUpdate = (fn) => listeners.add(fn);

export {
	ready,
	data,
	fetchedAt,
	onUpdate,
};
